import useTranslation from 'next-translate/useTranslation'
import React, { useEffect } from 'react'
import useMap from 'tennders-transactions/hooks/useMap'
import useOffers from 'tennders-market/offer/hooks/useOffers'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useSocket from 'tennders-common/hooks/useSocket'
import { STATUS_UNDER_NEGOTIATION } from 'tennders-stracture/libs/constants'
import GLoading from 'tennders-market/common/components/element/GLoading'
import { REFRESH_TYPES } from 'tennders-common/stores/socket/action'
import OfferSentMessage from '../first-offer/OfferSentMessage'
import SingleOffer from './single-offer/SingleOffer'

const OfferGroups = ({ transaction }) => {
  const { refresh } = useSocket()
  const {
    offers, pagination, fetchOffers, setSelectedOffer,
    isOfferSent, selectedOffer, loading
  } = useOffers()

  const { setTransaction, fetchTransaction } = useTransaction()

  const { setEditMode } = useMap()

  const { t } = useTranslation()

  useEffect(() => {
    if (transaction) {
      fetchOffers(transaction)
    }
  }, [transaction])

  useEffect(() => {
    if (!selectedOffer && offers && offers.length > 0) {
      setSelectedOffer(offers[0]?.lastOffer)

      if (offers[0]?.lastOffer?.isMine) {
        setEditMode(false)
      }
    }
  }, [offers])

  const refreshOffers = async () => {
    if (transaction?.status?.label !== STATUS_UNDER_NEGOTIATION) {
      const response = await fetchTransaction(transaction?.id)
      if (response?.id) {
        setTransaction(response)
      }
    }

    fetchOffers(transaction)
  }

  useEffect(() => {
    if (refresh === `${REFRESH_TYPES.TRANSACTION}-offer-${transaction?.id}`
    || refresh === 'offers') {
      refreshOffers()
    }
  }, [refresh])

  const offerView = loading ? <GLoading />
    : offers?.map((offer) => (
      <SingleOffer
        key={offer?.lastOffer?.id}
        transaction={transaction}
        offer={offer}
        offerCount={offers?.length}
        transactionIsMine={transaction?.isMine}
      />
    ))

  return (
    transaction?.status?.label === STATUS_UNDER_NEGOTIATION
      ? (
        <div className="p-20 bg-color-white br-10">
          <div className="d-flex align-center mb-10">
            <h3 className="bold mb-0">
              {t('offer:negotiation')}
            </h3>
            {transaction?.isMine && pagination?.totalItem > 0 && (
              <span className="text-12 ml-4">
                { t('offer:offerCount', { count: pagination?.totalItem })}
              </span>
            )}

          </div>

          <table className="tennders-table-zebra">
            <tbody>
              <tr>
                <td>
                  {isOfferSent
                    ? <OfferSentMessage counter form={isOfferSent} /> : offerView}
                </td>

              </tr>
            </tbody>
          </table>

        </div>
      ) : null
  )
}

export default React.memo(OfferGroups)
